import React, { useEffect, useState, useRef, useContext } from "react";
import { UsersContext } from "../../../providers/Users";
import "./statistics.css";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { Cloud_API_URL } from "../../../utils/constants";
import axios from "axios";

const Answers = ({ isAuth, userData, readingTestsScores, id }) => {
  const {
    answersData,
    setAnswersData,
    setUserEmail,
    user,
    getUser,
    getUsersInfo,
    setUser,
    getTestQuestions,
    userResults,
    ansrDate,
    ansrResTotal,
    resultFromOtherTest,
    setResultFromOtherTest,
    improvmentResultsTotal,
    setImprovmentResultsTotal,
    improvmentResults,
    setImprovmentResults,
    readingSDate,
    setReadingSDate,
    readingSData,
    setReadingSData,
    readingTestData,
    setReadingTestData,
    readingSDataRes,
    setReadingSDataRes,
    getReadingSpeedDate,
    calculatingReadingImprovment,
    calculatingTestReadingImprovment,
    checkStared,
    setUsers,
    loading,
    setLoading,
    readingChainData,
    setReadingChainData,
  } = useContext(UsersContext);
  const [showAnswers, setShowAnswers] = useState(true);
  // const [btnDisable, setBtnDisable] = useState(false);
  const ansRef = useRef();
  const quesRef = useRef();

  useEffect(() => {
    setUserEmail(userData.Email);
  }, [userData]);

  useEffect(() => {
    if (isAuth && userData) {
      handleSubmit();
    } else {
      return;
    }
  }, []);

  useEffect(() => {
    calculatingTestReadingImprovment(readingTestsScores);
  }, [readingTestsScores]);

  useEffect(() => {
    getUsersInfo();
  }, [checkStared]);

  useEffect(() => {
    setResultFromOtherTest([]);
    setImprovmentResults([]);
    getTestQuestions();
    checkAnswerCount();
    userResults(answersData);
  }, [answersData]);

  useEffect(() => {
    calculatingReadingImprovment();
    getReadingSpeedDate();
  }, [readingSData, readingTestData]);

  function toDateTime(secs) {
    var t = new Date(1970, 0, 1); // Epoch
    t.setSeconds(secs);
    return t;
  }

  const checkAnswerCount = () => {
    if (typeof ansRef.current != "undefined" && ansRef.current != null) {
      setTimeout(() => {
        const ansWrapper = document.querySelectorAll(".ansWrapper");
        const quesWrapper = document.querySelectorAll(".quesWrapper");
        [...ansWrapper].forEach((ansWrap) => {
          if (ansWrap.children.length === 15) {
            let li = document.createElement("li");
            ansWrap.appendChild(li).className = "table-row";
          }
        });
        [...quesWrapper].forEach((quesWrap) => {
          if (quesWrap.children.length === 15) {
            let li = document.createElement("li");
            quesWrap.appendChild(li).className = "table-row";
          }
        });
      }, 100);
    }
  };

  const getWeekNumberFromDate = (docDate) => {
    let userDocdate = new Date(docDate);
    let oneJan = new Date(userDocdate.getFullYear(), 0, 1);
    let numberOfDays = Math.floor(
      (userDocdate - oneJan) / (24 * 60 * 60 * 1000)
    );
    let result = Math.ceil((userDocdate.getDay() + 1 + numberOfDays) / 7);
    return result;
  };

  const userDetails = () => {
    return (
      <div className="userInfo">
        <h4>{`Användare namn: ${userData.FirstName}`}</h4>
        <p>{`/ Ålder: ${userData.Age}`}</p>
      </div>
    );
  };

  const showUserAnswers = () => {
    if (answersData.length > 0) {
      return (
        <ul className="responsive-table">
          <div
            className="col-q"
            style={answersData.length <= 3 ? { width: "100%" } : null}
          >
            <div className="table-shared-header"></div>
            <li className="table-header">
              <div className="col col-1">#</div>
              <div className="col col-2">
                Samsynstest
                <span className="tooltiptext">Samsynstest</span>
              </div>
            </li>
            <div ref={quesRef} className="quesWrapper">
              {answersData[0].details.map((elem, idx) => {
                return (
                  <li key={`question-${idx}`} className="table-row">
                    <div className="col col-1">{idx + 1}</div>
                    <Tooltip title={elem.question}>
                      <div className="col col-2">{elem.question}</div>
                    </Tooltip>
                  </li>
                );
              })}
            </div>
            <li className="table-row">
              <div className="col col-1">Total:</div>
            </li>
          </div>
          <div className="splitter">
            <div className="table-shared-header">Vecka</div>
            <div className="answers-columns">
              {answersData.map((ans, i) => {
                return (
                  <div key={i.toString()} className="answers-wrapper">
                    <li className="table-header">
                      <div className="col col-2">
                        {getWeekNumberFromDate(toDateTime(ans.answeredOn))}
                        <span className="tooltiptext">
                          {getWeekNumberFromDate(toDateTime(ans.answeredOn))}
                        </span>
                      </div>
                    </li>
                    <div ref={ansRef} className="ansWrapper">
                      {ans.details.map((a, idx) => {
                        return (
                          <li key={idx} className="table-row">
                            <div className="col col-3">{a.value}</div>
                          </li>
                        );
                      })}
                    </div>
                    <li className="table-row total">
                      <div className="col col-2">
                        {ans.total}
                        <span className="tooltiptext">{ans.total}</span>
                      </div>
                    </li>
                  </div>
                );
              })}
            </div>
          </div>
        </ul>
      );
    } else {
      return (
        <h3 key={"imvif554"} className="noData">
          No Data to show
        </h3>
      );
    }
  };

  const userImprovment = (resArr, dateArr, totalArr, title) => {
    if (resArr.length > 0) {
      return (
        <ul className="responsive-table">
          <div className="splitter">
            <div className="table-shared-header">{title}</div>
            <div className="result-table">
              <div className="answers-columns">
                {dateArr.map((date, i) => {
                  return (
                    <li key={`date-${i}`} className="table-header">
                      <div className="col col-2">
                        {getWeekNumberFromDate(date)}
                      </div>
                    </li>
                  );
                })}
              </div>
              <div className="result-columns">
                {resArr.map((arr, index) => (
                  <div key={index} className="res-cell">
                    {arr.map((item, ind) => (
                      <li key={ind} className="table-row">
                        <div className="col col-2">{item}</div>
                      </li>
                    ))}
                  </div>
                ))}
              </div>
              <div className="result-columns">
                {totalArr.map((val, idex) => (
                  <div key={idex} className="res-cell">
                    <li className="table-row">
                      <div className="col col-2"></div>
                    </li>
                    <li className="table-row">
                      <div className="col col-2">{val}</div>
                    </li>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </ul>
      );
    }
  };

  const showUserReadingSpeed = () => {
    const readingTypes = ["Teckenkedjor", "Ordkedjor", "Meningskedjor"];
    // setReadingSData(readingTestsScores);
    if (readingSData.length > 0) {
      return (
        <ul className="responsive-table head-color">
          <div className="splitter">
            <div className="table-shared-header"></div>
            <li className="table-header">
              <div className="col col-2">Läshastighet</div>
            </li>
            {readingTypes.map((r, idx) => {
              return (
                <li key={`reading-type-${idx}`} className="table-row">
                  <div className="col col-2">{r}</div>
                </li>
              );
            })}
          </div>
          <div className="splitter">
            <div className="table-shared-header">Vecka</div>
            <div className="answers-columns">
              {readingSData.map((rs, i) => {
                return (
                  <div key={i} className="answers-wrapper">
                    <li className="table-header">
                      <div className="col col-2">
                        {getWeekNumberFromDate(
                          toDateTime(rs.RecordedAtTime.seconds)
                        )}
                      </div>
                    </li>
                    <div className="ansWrapper">
                      <li className="table-row">
                        <div className="col col-3">{rs.ReadingSpeed_1}</div>
                      </li>
                      <li className="table-row">
                        <div className="col col-3">{rs.ReadingSpeed_2}</div>
                      </li>
                      <li className="table-row">
                        <div className="col col-3">{rs.ReadingSpeed_3}</div>
                      </li>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {readingSDataRes.length > 0 && (
            <div className="splitter">
              <div className="table-shared-header">Förbättring V</div>
              <div className="readingSpeed-columns">
                <div className="readingSpeed-header">
                  {readingSDate.map((rsd, i) => {
                    return (
                      <div key={i} className="readingSpeed-wrapper">
                        <li className="table-header">
                          <div className="col col-2">
                            {getWeekNumberFromDate(rsd)}
                          </div>
                        </li>
                      </div>
                    );
                  })}
                </div>
                {readingSDataRes.map((arr, i) => {
                  return (
                    <div key={i} className="readingSpeed-wrapper">
                      {arr.map((num, idx) => {
                        return (
                          <li key={idx} className="table-row">
                            <div className="col col-2">{`${num}%`}</div>
                          </li>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </ul>
      );
    }
  };

  const showProprietaryUserReadingSpeed = () => {
    const readingTypes = ["Teckenkedjor", "Ordkedjor", "Meningskedjor"];
    readingTestsScores.forEach((rs) => {
      rs.RecordedAtTime = {
        seconds: moment(rs.date).unix(),
      };
    });
    const readingSDate = getReadingSpeedDate(readingTestsScores);
    if (readingTestsScores.length > 0) {
      return (
        <ul className="responsive-table head-color">
          <div className="splitter">
            <div className="table-shared-header"></div>
            <li className="table-header">
              <div className="col col-2">Läshastighet</div>
            </li>
            {readingTypes.map((r, idx) => {
              return (
                <li key={idx} className="table-row">
                  <div className="col col-2">{r}</div>
                </li>
              );
            })}
          </div>
          <div className="splitter">
            <div className="table-shared-header">Vecka</div>
            <div className="answers-columns">
              {readingTestsScores.map((rs, i) => {
                return (
                  <div key={`reading-score-${i}`} className="answers-wrapper">
                    <li className="table-header">
                      <div className="col col-2">
                        {getWeekNumberFromDate(
                          toDateTime(rs.RecordedAtTime.seconds)
                        )}
                      </div>
                    </li>
                    <div className="ansWrapper">
                      <li className="table-row">
                        <div className="col col-3">{rs.letters_score}</div>
                      </li>
                      <li className="table-row">
                        <div className="col col-3">{rs.words_score}</div>
                      </li>
                      <li className="table-row">
                        <div className="col col-3">{rs.sentences_score}</div>
                      </li>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {readingChainData.length > 0 && (
            <div className="splitter">
              <div className="table-shared-header">Förbättring V</div>
              <div className="readingSpeed-columns">
                <div className="readingSpeed-header">
                  {readingSDate.map((rsd, i) => {
                    return (
                      <div key={i} className="readingSpeed-wrapper">
                        <li className="table-header">
                          <div className="col col-2">
                            {getWeekNumberFromDate(rsd)}
                          </div>
                        </li>
                      </div>
                    );
                  })}
                </div>
                {readingChainData.map((arr, i) => {
                  return (
                    <div key={i} className="readingSpeed-wrapper">
                      {arr.map((num, idx) => {
                        return (
                          <li key={idx} className="table-row">
                            <div className="col col-2">{`${num}%`}</div>
                          </li>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </ul>
      );
    }
  };

  // const handleClickSuggetion = email => {
  //   setUserEmail(email);
  //   localStorage.removeItem("answersData");
  //   localStorage.removeItem("readingSData");
  //   setSuggestion([]);
  // };

  const handleSubmit = () => {
    localStorage.removeItem("answersData");
    localStorage.removeItem("readingSData");
    setUser("");
    setReadingSData([]);
    setReadingSDataRes([]);
    setReadingSDate([]);
    setUserEmail("");
    setAnswersData([]);
    setResultFromOtherTest([]);
    setImprovmentResultsTotal([]);
    setImprovmentResults([]);
    setShowAnswers(false);
    getUser(userData.Email);
    setShowAnswers(true);
    // answersData.length > 1 ? setBtnDisable(false) : setBtnDisable(true);
  };

  const clearPerformedTestFlag = async () => {
    const userDocRef = doc(db, "UserData", id);
    await updateDoc(userDocRef, { performedTests: false });
    await axios.put(`${Cloud_API_URL}/user/${id}/update-field`, {
      field: "performed_test_today",
      value: false,
    });
    console.log("Performed test flag reset successfully.");
  };
  const generateReport = async () => {
    localStorage.setItem("readingTestData", JSON.stringify(readingTestsScores));
    clearPerformedTestFlag();
    window.open("/ResultsReport", "_blank");
  };

  if (loading)
    return (
      <div className="wrapper">
        <div className="spinner">
          <div className="spinner-1"></div>
          <div className="spinner-2"></div>
          <div className="spinner-3"></div>
        </div>
      </div>
    );

  return (
    <div>
      {user && userDetails()}
      {showAnswers ? (
        <>
          <button
            className={answersData.length > 1 ? "login-with-google-btn" : null}
            onClick={generateReport}
            disabled={answersData.length > 1 ? false : true}
          >
            Generate report
          </button>
          <div className="table-container">
            <div className="answers-content">
              {[
                <div key="user-answers">{showUserAnswers()}</div>,
                <div key="user-improvement-1">
                  {userImprovment(
                    resultFromOtherTest,
                    ansrDate,
                    ansrResTotal,
                    "Utveckling V"
                  )}
                </div>,
                <div key="user-improvement-2">
                  {userImprovment(
                    improvmentResults,
                    ansrDate,
                    improvmentResultsTotal,
                    "Förbättring V"
                  )}
                </div>,
              ]}
            </div>
            <div className="readingSpeed-content">{showUserReadingSpeed()}</div>
            <div className="readingSpeed-content">
              {showProprietaryUserReadingSpeed()}
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default Answers;
